import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If not on home page, navigate to home first
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => scrollToSection('hero'), 100);
              }}
              className="text-white font-bold text-xl tracking-widest hover:opacity-80 transition-opacity"
            >
              <div className="flex flex-col items-center">
                <span className="text-2xl">ACT</span>
                <span className="text-xs tracking-[0.3em] mt-1">ATLANTIC COAST TATTOO</span>
              </div>
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <button
              onClick={() => scrollToSection('artists')}
              className="text-white hover:text-gray-300 transition-colors uppercase text-sm tracking-wider"
            >
              Artists
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white hover:text-gray-300 transition-colors uppercase text-sm tracking-wider"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-gray-300 transition-colors uppercase text-sm tracking-wider"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-gray-300 transition-colors uppercase text-sm tracking-wider"
            >
              Contact
            </button>
            <button
              data-testid="nav-buy-vouchers"
              onClick={() => navigateToPage('/shop')}
              className="text-black bg-white hover:bg-gray-200 transition-colors uppercase text-sm tracking-wider px-4 py-1.5 -my-1.5"
            >
              Buy Vouchers
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-white p-2"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-gray-800">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button
              onClick={() => scrollToSection('artists')}
              className="block w-full text-left px-3 py-2 text-white hover:bg-gray-900 uppercase text-sm tracking-wider"
            >
              Artists
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-3 py-2 text-white hover:bg-gray-900 uppercase text-sm tracking-wider"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-3 py-2 text-white hover:bg-gray-900 uppercase text-sm tracking-wider"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-3 py-2 text-white hover:bg-gray-900 uppercase text-sm tracking-wider"
            >
              Contact
            </button>
            <button
              data-testid="nav-buy-vouchers-mobile"
              onClick={() => navigateToPage('/shop')}
              className="block w-full text-left px-3 py-2 text-white font-bold hover:bg-gray-900 uppercase text-sm tracking-wider"
            >
              Buy Vouchers
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;